var render = function (_h,_vm) {var _c=_vm._c;return _c('li',_vm._g({staticClass:"menu-item"},_vm.listeners),[_vm._t("default",[_c('a',_vm._b({attrs:{"href":_vm.props.url}},'a',_vm.props.anchorAttrs,false),[_vm._v("\n      "+_vm._s(_vm.props.text)+"\n    ")])],{"text":_vm.props.text})],2)}
var staticRenderFns = []

export { render, staticRenderFns }